"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isUndef = exports.isNumber = exports.isBoolean = exports.isString = exports.isFunction = exports.isObject = void 0;

exports.isObject = function (value) {
  return value !== null && typeof value === 'object';
};

exports.isFunction = function (value) {
  return typeof value === 'function';
};

exports.isString = function (value) {
  return typeof value === 'string';
};

exports.isBoolean = function (value) {
  return typeof value === 'boolean';
};

exports.isNumber = function (value) {
  return typeof value === 'number';
};

exports.isUndef = function (value) {
  return typeof value === 'undefined';
};